import { useState } from 'react';
import { platformsConfig } from '../platforms-config';
export var usePlatformSelectorHandlers = function () {
    var platforms = Object.values(platformsConfig);
    var _a = useState(''), selectedPlatform = _a[0], setSelectedPlatform = _a[1];
    var handleSelectedPlatformChanged = function (e) {
        setSelectedPlatform(e.currentTarget.value);
    };
    return {
        platforms: platforms,
        selectedPlatform: selectedPlatform,
        onSelectedPlatformChanged: handleSelectedPlatformChanged,
    };
};
